
.shopping-cart-btn__content {
    display: block;
    position: absolute;
    top: 90px;
    right: 10px;
    width: 300px;
    background: #fff;
    z-index: 99;
    max-height: calc(100vh - 115px);
    overflow-y: auto;

    transform: translateY(-500%);
    transition: transform .75s ease;
    box-shadow: 0 10px 20px rgb(45 50 55 / 20%);

    &--open {
        transform: translateY(0%);
    }
}